// Metadata build frontend.
//
// Nilainya ditanam saat `npm run build` di dalam Docker (lihat Dockerfile dan
// Jenkinsfile), bukan diketik manual per rilis. CRA mengganti referensi
// `process.env.REACT_APP_*` menjadi literal saat build, jadi penulisannya harus
// utuh -- tidak boleh diakses lewat variabel.

const UNKNOWN = 'unknown';

const clean = value => {
  const trimmed = (value || '').trim();
  return trimmed === '' ? UNKNOWN : trimmed;
};

export const frontendBuildInfo = {
  service: 'hydro-fe',
  version: clean(process.env.REACT_APP_VERSION),
  buildNumber: clean(process.env.REACT_APP_BUILD_NUMBER),
  commit: clean(process.env.REACT_APP_GIT_COMMIT),
  branch: clean(process.env.REACT_APP_GIT_BRANCH),
  buildTime: clean(process.env.REACT_APP_BUILD_TIME),
};

export const isUnknown = value => !value || value === UNKNOWN;

export const shortCommit = commit =>
  isUnknown(commit) ? UNKNOWN : String(commit).slice(0, 7);

export default frontendBuildInfo;
